import React from 'react';
import { PlusCircle, BarChart3, Users, TrendingUp } from 'lucide-react';

/**
 * Empty State Component for Dashboard
 * Shows when user has no data connections or metrics
 */
const EmptyState = ({ onGetStarted }) => {
  return (
    <div className="text-center py-16">
      <div className="flex justify-center mb-6">
        <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center">
          <BarChart3 className="w-12 h-12 text-gray-400" />
        </div>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        Welcome to CRO Agent!
      </h2>

      <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
        Connect your marketing platforms to start seeing insights, metrics, and analytics
        all in one place. Get started by connecting your first data source.
      </p>

      {/* Feature highlights */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8 max-w-4xl mx-auto">
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3">
            <TrendingUp className="w-6 h-6 text-blue-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">Track Performance</h3>
          <p className="text-sm text-gray-600">
            Monitor revenue, spend, and ROI across all your marketing channels
          </p>
        </div>

        <div className="text-center p-4">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-3">
            <Users className="w-6 h-6 text-green-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">Unified Data</h3>
          <p className="text-sm text-gray-600">
            Connect Google Ads, Meta, LinkedIn, HubSpot and more in one dashboard
          </p>
        </div>

        <div className="text-center p-4">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-3">
            <BarChart3 className="w-6 h-6 text-purple-600" />
          </div>
          <h3 className="font-semibold text-gray-900 mb-2">AI Insights</h3>
          <p className="text-sm text-gray-600">
            Get intelligent recommendations to optimize your marketing performance
          </p>
        </div>
      </div>

      {/* CTA Button */}
      <button
        onClick={onGetStarted}
        className="btn-primary text-lg px-8 py-3 inline-flex items-center space-x-2"
      >
        <PlusCircle className="w-5 h-5" />
        <span>Connect Your First Data Source</span>
      </button>

      <p className="text-sm text-gray-500 mt-4">
        Takes less than 2 minutes to set up
      </p>
    </div>
  );
};

export default EmptyState;
